import React, { useRef } from "react";
import Header from "../components/Navbar";
import Footer from "../components/Footer";
import "../styles/Home.css";
import Section1 from "../components/Section1";
import Work from "../components/WorkSection";
import Feature from "../components/FeatureSection";
import WalletSection from "../components/WalletSection";
import DoctorSection from "../components/DoctorSection";
import SignUp from "../components/SignupSection";

const Home = () => {
  // Create refs for each section
  const sectionRefs = {
    home: useRef(null),
    howItWorks: useRef(null),
    features: useRef(null),
    wallet: useRef(null),
    doctors: useRef(null),
  };

  const scrollToSection = (section) => {
    sectionRefs[section]?.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <Header scrollToSection={scrollToSection} />
      <div ref={sectionRefs.home}>
        <Section1 scrollToSection={scrollToSection} />
      </div>
      <div ref={sectionRefs.howItWorks}>
        <Work />
      </div>
      <div ref={sectionRefs.features}>
        <Feature />
      </div>
      <div ref={sectionRefs.wallet}>
        <WalletSection />
      </div>
      <div ref={sectionRefs.doctors}>
        <DoctorSection />
      </div>
      <SignUp />
      <Footer />
    </>
  );
};

export default Home;
